import { FunctionTypes } from '../../../components/ContributorSection/helpers';
var PREFIX_FOR_TEST_IDS = 'mailing-list-form';

/** test ids for form and sections inside it */
export var TestIds = {
  MAILING_LIST_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  MAILING_LIST_PUB_INFO: "".concat(PREFIX_FOR_TEST_IDS, "-mailing-list-pub-info-sec-test-id")
};
export var SECTION_TITLE = 'Online publication info';
export var MailingRadioRoleOptions = [FunctionTypes.AUTHOR];